const initialState = {
	creatingAccount: false,
	createdAccount: false,
	requestedAccountData: false,
	accountData: false,
	contactsData: false,

	errorMessage: '',

	isDirty: false,
	saveIsProcessing: null,
	saveIsProcessed: null,
	saveIsUnsuccessful: null,
	saveIsSuccessful: null,
	saveIsFinishing: null,
	saveError: null
}

export default function pageReducer( state = initialState, action ) {
	const { payload } = action

	switch ( action.type ) {
		// Signup:

		case 'SET_DATA':
			return {
				...state,
				...payload
			}

		case 'CREATING_ACCOUNT':
			return {
				...state,
				creatingAccount: true
			}

		case 'RECEIVE_ACCOUNT_DATA':
			return {
				...state,
				requestedAccountData: true,
				accountData: payload,
				loggedIn: true
			}

		case 'CREATED_ACCOUNT':
			return {
				...state,
				createdAccount: true,
				creatingAccount: false
			}

		case 'SHOW_SIGNUP_ERROR':
			return {
				...state,
				errorMessage: payload
			}

		case 'RECEIVE_CONTACTS_DATA':
			return {
				...state,
				contactsData: payload
			}

		// Save:

		case 'SET_DIRTY_STATE':
			return {
				...state,
				isDirty: payload
			}

		case 'SET_SAVE_PROCESSING':
			return {
				...state,
				saveIsProcessing: true,
				saveIsProcessed: false
			}

		case 'SET_SAVE_PROCESSED':
			return {
				...state,
				saveIsProcessed: true,
				saveIsProcessing: false
			}

		case 'SET_SAVE_SUCCESS':
			return {
				...state,
				isDirty: false,
				saveIsUnsuccessful: false,
				saveIsSuccessful: true
			}

		case 'SET_SAVE_ERROR':
			return {
				...state,
				saveIsSuccessful: false,
				saveIsUnsuccessful: true,
				saveError: payload
			}

		case 'SET_SAVE_FINISHING':
			return {
				...state,
				saveIsFinishing: true
			}

		case 'UNSET_SAVE_PROCESSED':
			return {
				...state,
				saveIsProcessed: false,
				saveIsProcessing: false,
				saveIsSuccessful: null,
				saveIsUnsuccessful: null,
				saveIsFinishing: null,
				saveError: null
			}
	}

	return state
}
